import React, { useEffect, useState, useMemo } from "react";
import { IoMdHeartEmpty } from "react-icons/io";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import PageTitle from "../store/PageTitle";
import { addToCart } from "../store/action/cartAction";
import PostHog from "posthog-js";
import { ToastContainer, toast } from "react-toastify";
import { proceedToCheckout } from "../store/action/checkAction";
import { storeRedirectUrl } from "../store/action/authAction";
import Cart from "../checkout/Cart";
import Airtel from "./img/pngegg (14).png";
import Mtn from "./img/pngegg (15).png";
import Visa from "./img/pngegg (16).png";
import Zamtel from "./img/ZamtelLogo_White-m85aPxq2.png";
import "./Details.css";
import { setLoading } from "../store/action/adsAction";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const Details = ({ isCartOpen, closeCart, closeCartRef, toggleLogin }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [isFavorite, setIsFavorite] = useState(false);

  // navigate
  const { id } = useParams();
  const location = useLocation();

  const [product, setProduct] = useState(null);
  const dispatch = useDispatch();
  const stateProduct = location.state?.product;
  console.log("data from state", stateProduct);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  // const cartItems = useSelector((state) => state.cart.cartItems);

  const navigate = useNavigate();

  // const handleGoBack = () => {
  //   navigate(-1);
  // };

  // logging for debugging state passed from products page to details page
  useEffect(() => {
    console.log("=== DETAILS PAGE ===");
    console.log("URL:", location.pathname);
    console.log("STATE:", location.state);
  }, [location.pathname, location.state]);

  const [selectedColor, setSelectedColor] = useState(
    location.state?.selectedVariantLabel || "any",
  );

  const variants = useMemo(() => product?.variants || [], [product?.variants]);
  const colors = product?.colors || [];
  const itemPhotos = product?.itemPhotos || [];

  const [selectedVariant, setSelectedVariant] = useState(null);

  useEffect(() => {
    if (variants.length === 0) {
      setSelectedVariant(null);
      return;
    }

    setSelectedVariant((current) =>
      current !== null && variants[current] ? current : 0,
    );
  }, [variants]);

  const displayPrice =
    selectedVariant !== null && variants[selectedVariant]
      ? variants[selectedVariant].price
      : (product?.price ?? variants[0]?.price);

  // const productPrice = (item) =>
  //   Number(item?.selectedVariant?.price ?? item?.price ?? 0);

  // const totalAmount = cartItems.reduce(
  //   (total, item) => total + productPrice(item) * Number(item.quantity || 0),
  //   0,
  // );

  const handleCheckout = () => {
    if (!product) {
      toast.error("Product details are not ready yet.");
      return;
    }

    const checkoutItem = {
      ...product,
      quantity,
      selectedVariant: variants[selectedVariant] || null,
      selectedColor:
        selectedColor && typeof selectedColor === "object"
          ? selectedColor
          : null,
      price: variants[selectedVariant]?.price ?? product?.price ?? 0,
    };

    const checkoutItems = [checkoutItem];
    const checkoutTotal = checkoutItems.reduce(
      (total, item) =>
        total +
        Number(item.selectedVariant?.price ?? item.price ?? 0) *
          Number(item.quantity || 1),
      0,
    );

    console.log("Checkout payload", checkoutItems, checkoutTotal);

    PostHog.capture("Checkout Initiated", {
      property: "Total Amount",
      value: checkoutTotal,
    });

    dispatch(proceedToCheckout(checkoutItems, checkoutTotal));
    navigate("/CheckOut");
    closeCart();
  };

  const handleQuantityChange = (action) => {
    if (action === "increase") setQuantity((p) => p + 1);
    if (action === "decrease" && quantity > 1) setQuantity((p) => p - 1);
  };

  const handleAddToCart = (product, selectedVariant, selectedColor) => {
    try {
      dispatch(addToCart(product, quantity, selectedVariant, selectedColor));
      toast.success("Successfully added to cart 🥳");

      PostHog.capture("Add to Cart", {
        property: "Product Name",
        value: product.item_name,
      });
      PostHog.capture("Add to Cart", {
        property: "Product Price",
        value: product.price,
      });
    } catch (error) {
      toast.error(`Error adding to cart: ${error.message}`);
    }
  };

  useEffect(() => {
    const stateProduct = location.state?.product;

    if (stateProduct && String(stateProduct.id) === id) {
      setProduct(stateProduct);
      return;
    }

    const fetchProduct = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${serverUrl}/get-product/${id}`);
        if (!response.ok) throw new Error("Failed to fetch product");
        const data = await response.json();
        setProduct(data.product);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id, location.state]);

  const handleSocialLogin = () => {
    // Store the path only, not full URL
    const currentPath = window.location.pathname + window.location.search;
    dispatch(storeRedirectUrl(currentPath));
    toggleLogin(true);
    closeCart();
    console.log("this is my redirect url", currentPath);
  };

  return (
    <div className="details-container">
      <div className="product-layout">
        <PageTitle title={product?.item_name} />

        {/* Images */}
        <div className="image-section">
          <div className="thumbnail-container">
            {itemPhotos.map((img, index) => (
              <div
                key={index}
                className={`thumbnail ${
                  selectedImage === index ? "thumbnail-active" : ""
                }`}
                onClick={() => setSelectedImage(index)}
              >
                <img src={img} alt="" />
              </div>
            ))}
          </div>
          <div className="main-image-container">
            <img
              src={itemPhotos[selectedImage]}
              alt={product?.item_name}
              className="main-image"
            />
          </div>
        </div>

        {/* Details */}
        <div className="details-section">
          <div className="header">
            <div className="detail-product-info">
              <p className="category">{product?.category}</p>
              <h1 className="product-name">{product?.item_name}</h1>
              <p className="price">
                <span className="currency">ZMW</span>
                <span className="amount">{displayPrice}</span>
              </p>
            </div>

            <button
              className={`favorite-btn ${isFavorite ? "favorite-active" : ""}`}
              onClick={() => setIsFavorite(!isFavorite)}
            >
              <IoMdHeartEmpty
                size={24}
                fill={isFavorite ? "#ff4444" : "none"}
                color={isFavorite ? "#ff4444" : "#666"}
              />
            </button>
          </div>

          {/* Colors */}
          {colors.length > 0 && (
            <div className="section">
              <label>Colors:</label>
              <div className="color-options">
                {colors.map((color) => (
                  <button
                    key={color.name}
                    className={`color-button ${
                      selectedColor?.name === color.name ? "active" : ""
                    }`}
                    onClick={() => setSelectedColor(color)}
                    style={{ backgroundColor: color.code }}
                    title={color.name}
                  />
                ))}
              </div>
            </div>
          )}
          {variants?.length > 0 && (
            <div className="variant">
              <label>Variant:</label>
              <div className="variant-options">
                {variants?.map((v, index) => (
                  <button
                    key={index}
                    className={`variant-button ${selectedVariant === index ? "active" : ""}`}
                    onClick={() => setSelectedVariant(index)}
                  >
                    {v.name}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Quantity */}
          <div className="section">
            <label>Quantity:</label>
            <div className="quantity-container">
              <button onClick={() => handleQuantityChange("decrease")}>
                <FaMinus />
              </button>
              <span>{quantity}</span>
              <button onClick={() => handleQuantityChange("increase")}>
                <FaPlus />
              </button>
            </div>
          </div>

          {/* Actions */}
          <div className="action-buttons">
            <button
              className="add-to-cart"
              onClick={() =>
                handleAddToCart(
                  product,

                  variants[selectedVariant],
                  selectedColor,
                )
              }
            >
              ADD TO CART
            </button>
            {isAuthenticated ? (
              <button className="buy-now" onClick={handleCheckout}>
                BUY NOW
              </button>
            ) : (
              <button className="buy-now" onClick={handleSocialLogin}>
                Login to Buy
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Description */}
      <div className="main-description">
        <div className="description-section">
          <h2>Description</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(product?.description),
            }}
          />
        </div>
        <div className="descripton-payments">
          <div className="description-payment-img">
            <img src={Mtn} alt="Payment Methods" />
            <img src={Visa} alt="Payment Methods" />
            <img src={Airtel} alt="Payment Methods" />
            <img src={Zamtel} alt="Payment Methods" />
          </div>
        </div>
      </div>

      <ToastContainer autoClose={3000} />

      {isCartOpen && (
        <Cart
          closeCart={closeCart}
          toggleLogin={toggleLogin}
          closeCartRef={closeCartRef}
        />
      )}
    </div>
  );
};

export default Details;
